import { AxiosInstance, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export interface GetFavPropertyIdsResponseData extends ResponseData {
  data: string[]
}
export interface GetFavPropertyIdsResponse extends AxiosResponse {
  data: GetFavPropertyIdsResponseData
}
export function getAllFavoritePropertyIdsApi(
  axiosInstance: AxiosInstance,
): Promise<GetFavPropertyIdsResponse> {
  return axiosInstance({
    method: "get",
    url: `/user/favouritelist/get-all-favouritelist-properties-by-userid`,
  }) as Promise<GetFavPropertyIdsResponse>
}
